import { z } from 'zod';
export const contactSearchFiltersSchema = z.object({
    domain: z.array(z.string()).default([]),
    jobLevel: z.array(z.string()).default([]),
    jobFunction: z.array(z.string()).default([]),
    jobTitle: z.array(z.string()).default([]),
    jobTitleKeyword: z.array(z.string()).default([]),
    businessEmail: z.array(z.string()).default([]),
    firstName: z.array(z.string()).default([]),
    lastName: z.array(z.string()).default([]),
});
//# sourceMappingURL=ContactSearch.js.map